import PropTypes from "prop-types";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import { changeLanguage, multilanguage } from "redux-multilanguage";
import { changeCurrency } from "../../../../redux/actions/currencyActions";
import { LANGUAGE_LABELS, getAvailableLanguages, getDefaultLanguage, changeLanguageUrl } from "../../../../utils/languages";
import { CURRENCIES } from "../../../../utils/constants/currencies";

// Language and currency dropdowns plus the phone number from the navigation, shown at the
// right end of the trust bar.
const LanguageCurrencyChanger = ({ currency, changeCurrency, currentLanguageCode, dispatch, phone }) => {
    const history = useHistory();
    const location = useLocation();
    const siteData = useSelector((state) => state.siteData);
    const availableLanguages = getAvailableLanguages(siteData);
    const defaultLanguage = getDefaultLanguage(siteData);

    const changeLanguageTrigger = (e) => {
        const languageCode = e.target.value;
        dispatch(changeLanguage(languageCode));
        changeLanguageUrl(location, history, languageCode, defaultLanguage, availableLanguages);
    };

    return (
        <div className="language-currency-wrap">
            {availableLanguages.length > 1 && (
                <div className="same-language-currency language-style">
                    <span>
                        {LANGUAGE_LABELS[currentLanguageCode] || currentLanguageCode} <i className="fa fa-angle-down" />
                    </span>
                    <div className="lang-car-dropdown">
                        <ul>
                            {availableLanguages.map((lang) => (
                                <li key={lang}>
                                    <button value={lang} onClick={(e) => changeLanguageTrigger(e)}>
                                        {LANGUAGE_LABELS[lang] || lang}
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            )}
            <div className="same-language-currency use-style">
                <span>
                    {currency.currencyName} <i className="fa fa-angle-down" />
                </span>
                <div className="lang-car-dropdown">
                    <ul>
                        {Object.keys(CURRENCIES).map((name) => (
                            <li key={name}>
                                <button value={name} onClick={() => changeCurrency(name)}>
                                    {name}
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
            {phone && (
                <div className="same-language-currency">
                    <p>
                        Call us <a href={`tel:${phone.replace(/\s+/g, "")}`}>{phone}</a>
                    </p>
                </div>
            )}
        </div>
    );
};

LanguageCurrencyChanger.propTypes = {
    changeCurrency: PropTypes.func,
    currency: PropTypes.object,
    currentLanguageCode: PropTypes.string,
    dispatch: PropTypes.func,
    phone: PropTypes.string,
};

const mapStateToProps = (state) => ({
    currency: state.currencyData,
});

const mapDispatchToProps = (dispatch) => ({
    dispatch,
    changeCurrency: (currencyName) => {
        dispatch(changeCurrency(currencyName));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(multilanguage(LanguageCurrencyChanger));